import { createConfirmation } from 'react-confirm';
import { noop } from '../../utilities/functions';
import { ConfirmDialog } from './Confirm/Confirm';

/* TODO: might replace react-confirm with a redux managed confirm dialog */

const confirm = createConfirmation(ConfirmDialog);

export const alertDialog = (options = {}) => {
  const { message, okHandler, cancelHandler, ...rest } = options;

  return confirm({ confirmation: message, options: rest }).then(
    okHandler || noop,
    cancelHandler || noop
  );
};
